module.exports = __webpack_public_path__ + "img/import.64d69652.svg";